import {BehaviorSubject, EMPTY, merge, of} from "rxjs";
import {catchError, mergeMap} from "rxjs/operators";
import {ErrorSources, setLastError} from "../services/error/error-actions";

export class EpicRegistry {
  
  constructor(initialEpic = () => EMPTY) {
    this.allEpics = [initialEpic];
    this.epic$ = new BehaviorSubject(initialEpic);
  }

  register = (...epics) => {
    const newEpics = epics.filter(epic => !this.allEpics.includes(epic)); // Add epics only once.
    for (const epic of newEpics) {
      this.allEpics.push(epic);
      this.epic$.next(epic);
    }
  };

  rootEpic = (...args) =>
    this.epic$.pipe(
      mergeMap((epic) => epic(...args).pipe(
        catchError((error, source$) => {
          console.error("REDUX_MIDDLEWARE ERROR", error);
          return merge(
            of(setLastError(`${error}`.replace(/^Error: /, ""), ErrorSources.REDUX_MIDDLEWARE, error.stack)),
            source$
          );
        })
      ))
    );
}

export const epicRegistry = new EpicRegistry();